import React from 'react';
import { useObservable } from 'react-use-observable';

import { CloseCircleOutlined as Cancel, CheckCircleOutlined as CheckCircle } from '@ant-design/icons';

import { EHintPath } from 'v2/interfaces/hint';
import { hintFactory } from 'v2/services/hint';

export type hintTypes = 'digital' | 'physical' | 'service';

interface IHint {
  type: hintTypes;
  can?: boolean;
  cant?: boolean;
}

const Hints = ({ type, can, cant }: IHint) => {
  const [hints] = useObservable(() => hintFactory.getHints(EHintPath.NEW_PRODUCT), []);
  if (!hints?.length) return null;
  let hintsByType = hints.filter(h => h.link === type);
  if (can) hintsByType = hintsByType.filter(h => h.label === 'hint-can');
  if (cant) hintsByType = hintsByType.filter(h => h.label === 'hint-cant');
  if (!hintsByType.length) return null;
  return (
    <div className='border-border rounded border bg-white shadow-xs'>
      <ul className='m-0 list-none p-0'>
        {hintsByType.map(h => {
          if (h.name === 'title') {
            return (
              <li key={h.hint} className='px-4 py-2'>
                <strong className='text-base'>{h.hint}</strong>
              </li>
            );
          }

          return (
            <li key={h.hint} className='flex items-start gap-3 px-4 py-2'>
              <span className='mt-0.5' style={{ minWidth: 20 }}>
                {h.label === 'hint-can' && <CheckCircle style={{ color: 'green' }} />}
                {h.label === 'hint-cant' && <Cancel style={{ color: 'red' }} />}
              </span>
              <span>{h.hint}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Hints;
